import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import HomeBannerForm from "../../component/admin/formComponents/HomeBannerForm";
import { fetchHomeBannerCategories } from "../../action/getHomeBannerCategory";
import { fetchHomeBannersData } from "../../action/homeBannersActions";

export default function AddHomeBanner() {
  const token = useSelector((state) => state.auth.token);
  const bannersData = useSelector((state) => state.homeBanners);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      dispatch(fetchHomeBannerCategories(token));
      dispatch(fetchHomeBannersData(token, 1));
    }
  }, [dispatch, token]);

  const usedCategoryIds = useMemo(() => {
    const rows = bannersData?.data?.data?.rows || bannersData?.data?.rows || [];
    return rows
      .map((b) => Number(b.category))
      .filter((id) => !Number.isNaN(id));
  }, [bannersData]);

  const formik = useFormik({
    initialValues: {
      category: "default",
      image: "",
      banner_name: "",
      sort_order: 0,
    },
    validationSchema: Yup.object().shape({
      category: Yup.number("Please enter integer value")
        .required("Category is Required")
        .typeError("Category is Required"),
      image: Yup.mixed().required("Banner Image is required"),
      banner_name: Yup.string().max(120, "Title is too long"),
      sort_order: Yup.number()
        .typeError("Sort order must be a number")
        .min(0, "Sort order cannot be negative"),
    }),
    onSubmit: async (values) => {
      if (usedCategoryIds.includes(Number(values.category))) {
        toast.error(
          "A banner already exists for this category. Edit that banner instead."
        );
        return;
      }
      setLoading(true);
      const data = new FormData();
      data.append("category", values.category);
      data.append("image", values.image);
      data.append("banner_name", values.banner_name.trim());
      data.append("sort_order", values.sort_order);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/createHomeBanner`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          toast.success(response.data.message);
          navigate("/admin/dashboard/home-banners");
        } else {
          toast.error(response.data.message);
        }
      } catch (e) {
        toast.error(e?.response?.data?.message || "error !!");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <React.Fragment>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress sx={{ color: "#ef364e" }} />
      </Backdrop>
      <Box className="free_votes_page">
        <Box className="page_title">
          <Typography variant="h1" component="h1">
            Create Home Banner
          </Typography>
        </Box>

        <HomeBannerForm
          formik={formik}
          edited={false}
          usedCategoryIds={usedCategoryIds}
        />
      </Box>
    </React.Fragment>
  );
}
